/*
 * @Author: cc
 * @LastEditTime: 2021-04-27 15:14:53
 */
import { createStore, applyMiddleware } from 'redux'
import { combineReducers } from 'redux'
import { navOptions } from './options'
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger';
import { videoStatus } from "./video";
import { initData,userInfo,InitPageData } from './initData'
// redux 长存储
import { persistStore, persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session'
const logger = createLogger();
const storageConfig = {
  key: 'root', // 必须有的
  storage: storageSession, // 缓存机制
}
const reducers = combineReducers({
  navOptions,
  initData,
  InitPageData,
  userInfo,
  videoStatus,
})
const myPersistReducer = persistReducer(storageConfig, reducers)
const store = createStore(myPersistReducer, applyMiddleware(
  thunkMiddleware,
  logger as  any
))
export const persistor = persistStore(store)
export default store
